import {IApiModel} from 'app/original-models/api-model.interface';

export class Account implements IApiModel<Account> {
    id: number;
    name: string;
    bankId: number;
    bankName: any;
    // icon: string;
    // type: string;
    iban: string;
    // bic: string;
    accountTypeName: string;
    currency: string;
    balance: number;
    alias: number;
    bankConnectionId: number;
    status: string;
    companies: String[];
    isChecked: boolean;
    isDisabled: boolean;
    transaction_count: number;
    accountId: number;
    sourceId: number;
    overdraftLimit: any;
    createdBy: string;
    dateCreated: any;
    lastSuccessfulUpdate: any;
    lastTransaction: any;
    isActive: boolean;
    real_account_id;
    limits: any[];
    type_name: string;

    getApiModel(): any {
        return undefined;
    }

    setFromApiModel(apiModel: any): this {
        this.id = apiModel.id;
        this.name = apiModel.name;
        if (apiModel.bank_connection) {
            this.bankId = apiModel.bank_connection.bank_id;
            this.bankName = apiModel.bank_connection.bank?.name;
        }
        this.transaction_count = apiModel.transaction_count;
        this.companies = apiModel.companies;
        this.bankConnectionId = apiModel.bank_connection;
        this.accountTypeName = apiModel.type_name;
        this.iban = apiModel.iban;
        if (apiModel.status) {
            this.status = apiModel.status;
        }
        this.currency = apiModel.currency;
        this.balance = apiModel.balance;
        this.alias = apiModel.alias;
        this.overdraftLimit = apiModel.overdraft_limit;
        this.limits = apiModel.limits;
        this.sourceId = apiModel.source_id;
        this.real_account_id = apiModel.real_account_id;

        this.dateCreated = apiModel.date_created;
        this.createdBy = apiModel.createdBy;
        this.lastSuccessfulUpdate = apiModel.last_successful_update;
        this.lastTransaction = apiModel.last_transaction;
        this.isActive = apiModel.is_active;
        this.type_name = apiModel.type_name;
        return this;
    }
}
